module.exports = __webpack_public_path__ + "static/media/logo_atise.28f7f5d3.png";